import React from 'react'
import Footer from '../Compponents/Footer/Footer'
import { Outlet } from 'react-router-dom'

export default function LayoutLogin() {
  return (
    <div>
        <Outlet/>
    </div>
  )
}
